import { NgIf } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  standalone: true,
  imports: [NgIf],
})
export class NavbarComponent implements OnInit {
  displayName = 'User';
  userRole = '';
  private readonly cookiePath = environment.COOKIE_PATH;

  constructor(
    private router: Router,
    private cookieService: CookieService,
  ) {}

  public ngOnInit(): void {
    this.displayName = this.cookieService.get('user_name') || 'User';
    this.userRole = this.cookieService.get('role') || 'Admin';
  }

  logout(): void {
    const cookies: string[] = Object.keys(this.cookieService.getAll());
    for (const cookie of cookies) {
      this.cookieService.delete(cookie, this.cookiePath);
      this.cookieService.set(cookie, '', {
        expires: new Date('Thu, 01 Jan 1970 00:00:00 GMT'),
        path: this.cookiePath,
      });
    }
    this.router.navigate(['/login']);
  }
}
